enum MenuOptionKey {
  PricePayment = 'price-payment',
  MakeModel = 'make-model',
  BodyType = 'body-type'
}

export enum MenuOptionLabel {
  None = 'none',
  PricePayment = 'Payment & Price',
  MakeModel = 'Make & Model',
  BodyType = 'Body Type'
}

const menuOptions: Array<{ key: MenuOptionKey; label: MenuOptionLabel }> = [
  { key: MenuOptionKey.PricePayment, label: MenuOptionLabel.PricePayment },
  { key: MenuOptionKey.MakeModel, label: MenuOptionLabel.MakeModel },
  { key: MenuOptionKey.BodyType, label: MenuOptionLabel.BodyType }
];

export default menuOptions;
